import "./css/style.css";

export default function PxmarketsLoader() {
    return (
        <div className={"pxmarkets-loader-container my-4"}>
            <svg width="40" height="40" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <linearGradient id="pxL40Blue" x1="0" y1="0" x2="0.4" y2="1">
                        <stop offset="0%"   stopColor="#b0ccff"/>
                        <stop offset="50%"  stopColor="#1a44cc"/>
                        <stop offset="100%" stopColor="#060e50"/>
                    </linearGradient>
                    <linearGradient id="pxL40Silver" x1="0.5" y1="0" x2="0.3" y2="1">
                        <stop offset="0%"   stopColor="#d4d8e8"/>
                        <stop offset="55%"  stopColor="#888ea8"/>
                        <stop offset="100%" stopColor="#404858"/>
                    </linearGradient>
                </defs>
                <style>{`
                    @keyframes pxBreatheUp40   { 0%,100%{transform:translate(2px,-3px)} 50%{transform:translate(6px,-10px)} }
                    @keyframes pxBreatheDown40 { 0%,100%{transform:translate(-2px,3px)} 50%{transform:translate(-6px,10px)} }
                    .px-l40-b { animation:pxBreatheUp40   1.4s ease-in-out infinite; transform-box:fill-box; transform-origin:center; }
                    .px-l40-s { animation:pxBreatheDown40 1.4s ease-in-out infinite; transform-box:fill-box; transform-origin:center; }
                `}</style>
                <polygon className="px-l40-b" points="19,10 89,10 80,72 62,72 68,28 34,28 16,28" fill="url(#pxL40Blue)"/>
                <polygon className="px-l40-s" points="16,28 7,90 77,90 80,72 62,72 28,72 34,28" fill="url(#pxL40Silver)"/>
            </svg>
        </div>
    );
}
